import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
const slides = [{
  title: '让留学链接多元人生',
  subtitle: '指南者留学 · 专注海外名校申请',
  cta: '了解更多',
  bg: 'linear-gradient(135deg,#2b6ef5 0%,#5a93ff 100%)',
  to: '/mine'
}, {
  title: '免费 AI 留学评估',
  subtitle: '一键测出冲稳保院校清单',
  cta: '立即评估',
  bg: 'linear-gradient(135deg,#7C3AED 0%,#3B82F6 100%)',
  to: '/ai-match'
}, {
  title: '申请全流程规划',
  subtitle: '专属时间线 + 背景提升建议',
  cta: '开始规划',
  bg: 'linear-gradient(135deg,#FF8E2B 0%,#FF5B8C 100%)',
  to: '/planner'
}];
export function HomeBanner() {
  const [i, setI] = useState(0);
  const nav = useNavigate();
  useEffect(() => {
    const t = setInterval(() => setI(v => (v + 1) % slides.length), 4500);
    return () => clearInterval(t);
  }, []);
  return <div className="px-3 pt-3" data-id="element-75">
      <div className="relative h-36 rounded-2xl overflow-hidden" data-id="element-76">
        <AnimatePresence mode="wait" data-id="element-77">
          <motion.button key={i} onClick={() => nav(slides[i].to)} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.4
        }} className="absolute inset-0 flex flex-col justify-center px-5 text-white text-left" style={{
          background: slides[i].bg
        }} data-id="element-78">
            <div className="text-[11px] bg-white/25 backdrop-blur rounded-full px-2 py-0.5 w-fit mb-2" data-id="element-79">
              {slides[i].subtitle}
            </div>
            <div className="text-2xl font-extrabold leading-tight drop-shadow-sm" data-id="element-80">
              {slides[i].title}
            </div>
            <span className="mt-3 bg-white text-blue-600 text-xs font-bold rounded-full px-4 py-1.5 w-fit" data-id="element-81">
              {slides[i].cta} ›
            </span>
          </motion.button>
        </AnimatePresence>
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5" data-id="element-82">
          {slides.map((_, idx) => <span key={idx} className={`h-1 rounded-full transition-all ${idx === i ? 'w-4 bg-white' : 'w-1.5 bg-white/50'}`} data-id="element-83" />)}
        </div>
      </div>
    </div>;
}